function getItemOptions() {
  var _this$props = this.props,
      renderItem = _this$props.renderItem,
      renderCollapseIcon = _this$props.renderCollapseIcon,
      handler = _this$props.handler,
      childrenProp = _this$props.childrenProp;
  var dragItem = this.state.dragItem;
  return {
    dragItem: dragItem,
    childrenProp: childrenProp,
    renderItem: renderItem,
    renderCollapseIcon: renderCollapseIcon,
    handler: handler,
    onDragStart: this.onDragStart,
    onMouseEnter: this.onMouseEnter,
    isCollapsed: this.isCollapsed,
    onToggleCollapse: this.onToggleCollapse
  };
}

export { getItemOptions };
//# sourceMappingURL=getItemOptions.js.map
